import { BlockColorType } from '../../../enum/block-color.enum';
import { IBlockDataModelConstructor } from '../../../interface/block/block-data-contructor.interface';

export const blockBackgroundColor = (backgroundColor: BlockColorType) => (component: IBlockDataModelConstructor) => {
  component.backgroundColor = backgroundColor;
  return component;
};
